import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const stackrox = defineConnector({
  identifier: "stackrox",
  name: "StackRox",
  tagLine: "Red Hat Advanced Cluster Security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://central.example.com"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up StackRox",
      items: [
        {
          kind: "markdown",
          content:
            "In Central, open **Platform Configuration → Integrations → Authentication Tokens → API Token**. Generate a token with cluster read access and copy it. Enter the Central HTTPS URL and token below. See [API token setup](https://docs.redhat.com/en/documentation/red_hat_advanced_cluster_security_for_kubernetes/4.8/html/configuring/configure-api-token).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://central.example.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "StackRox is self-hosted. Replace the documented local example https://localhost:8000 with the HTTPS address of the RHACS Central instance. For RHACS Cloud Service, obtain the Central API Endpoint, including its port, from the ACS instance details in the Red Hat Hybrid Cloud Console.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText: "A Central API token with cluster read access.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://central.example.com").trim().replace(/\/+$/, "") +
        "/v1/clusters",
      ...{ method: "GET", expectedBodyContains: ['"clusters"'] },
    }),
  },
});
